import { Box } from "@mui/material";

function ContactForm() {
  return (
    <Box>
      About page
    </Box>
  )
}

export default ContactForm;